import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["uploadForm", "submitButton"]

  toggleUploadForm() {
    if (this.hasUploadFormTarget) {
      this.uploadFormTarget.classList.toggle("hidden")
    }
  }

  startUpload() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.innerHTML = '<i class="ph ph-spinner ph-spin mr-1.5"></i> Uploading...'
    }
  }

  resetForm(event) {
    this.restoreButton()

    if (event.detail.success && this.hasUploadFormTarget) {
      const form = this.uploadFormTarget.querySelector("form")
      if (form) form.reset()
      this.uploadFormTarget.classList.add("hidden")
    }
  }

  restoreButton() {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.innerHTML = 'Upload'
    }
  }
}
